import { Navigate, useParams } from 'react-router-dom';
import { MARKETPLACE } from '@/lib/marketplacePaths';

/** Legacy /property/:slugOrId → /grenada/property/:slugOrId */
export function LegacyPropertyDetailRedirect() {
  const { slugOrId = '' } = useParams<{ slugOrId: string }>();
  return <Navigate to={`/grenada/property/${slugOrId}`} replace />;
}

/** Legacy /classifieds/:id → /grenada/classifieds/:id */
export function LegacyClassifiedDetailRedirect() {
  const { id = '' } = useParams<{ id: string }>();
  return <Navigate to={`${MARKETPLACE.classifieds}/${id}`} replace />;
}
